import {
	UPDATE_LAST_STEP_SUCCESSFULLY,
	UPDATE_LAST_STEP_FAILED,
	REGISTER_LAST_STEP_SUCCESSFULLY,
	REGISTER_LAST_STEP_FAILED,
	GET_LAST_STEP_UUID_SUCCESSFULLY,
	GET_LAST_STEP_UUID_FAILED
  } from '../Actions/types';
  
  const INITIAL_STATE = {
	data: {},
  	error: {},
  }
  
  const customerStepReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	case UPDATE_LAST_STEP_SUCCESSFULLY:
	  return {...state, ...INITIAL_STATE, data: action.data }
	case UPDATE_LAST_STEP_FAILED:
	  return {...state, ...INITIAL_STATE, error: action.data }
	case REGISTER_LAST_STEP_SUCCESSFULLY:
	  return {...state, ...INITIAL_STATE, data: action.data }
	case REGISTER_LAST_STEP_FAILED:
	  return {...state, ...INITIAL_STATE, error: action.data }
	case GET_LAST_STEP_UUID_SUCCESSFULLY:
		return {...state, ...INITIAL_STATE, data: action.data }
	case GET_LAST_STEP_UUID_FAILED:
		return {...state, ...INITIAL_STATE, error: action.data }
	default:
	  return { ...state }
	}
  };
  
  export default customerStepReducer;